import React, { Fragment, useEffect, useState } from 'react';
import { Button } from 'components/Button';
import { Modal } from 'components/modal/Modal';
import { FormInput } from 'components/form/FormInput';
import './DealTitleModalEdit.scss';
/**
 * @component DealTitleModalEdit
 * @since 1.0.0
 * @hidden
 */
export function DealTitleModalEdit(props) {
    const { onClose, dealTitle, onConfirm } = props;
    const [title, setTitle] = useState(dealTitle);
    useEffect(() => {
        setTitle(dealTitle);
    }, [dealTitle]);
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { label: t('Cancel'), onPress: onClose, noPadding: true }),
        React.createElement("div", { className: "deal-title-modal-edit-button-container" },
            React.createElement(Button, { style: "primary", label: t('Apply'), onPress: () => onConfirm(title !== null && title !== void 0 ? title : '') }))));
    return (React.createElement("div", { className: "deal-title-modal-edit" },
        React.createElement(Modal, { picto: "pencil", title: t('Edit Deal Title'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "deal-title-modal-edit-content" },
                React.createElement(FormInput, { name: "dealTitle", label: t('Deal Title'), placeholder: t('Enter Title'), defaultValue: dealTitle, value: title, onChange: (value) => setTitle(value) })))));
}
